import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import NotAllowed from 'src/permissions/not-allowed';
import Restricted from 'src/permissions/restricted';
import BestSellingProductsGuard from './components/BestSellingProductsGuard';

const BestSellingProductsRootPage: FC = () => {
  return (
    <Switch>
      <Route path="/best-selling-products" exact>
        <Restricted to="ROLE_MC_FASTLISTING" fallback={<NotAllowed />}>
          <BestSellingProductsGuard />
        </Restricted>
      </Route>
    </Switch>
  );
};

export default BestSellingProductsRootPage;